import React from 'react';
import { useTranslation } from 'react-i18next';
import { ASSIGNABLE_ROLES } from '../../../utils/rolesMatrix';

export default function MembersTab({
  members,
  currentUserRole,
  onChangeRole,
  onRemoveMember
}) {
  const { t } = useTranslation('organization');
  // Acciones de gestión de miembros (remover, columna de acciones): owner + admin
  // (admin tiene canRemoveMembers). Cambiar el ROL de un miembro es owner-only:
  // el server exige requireRole('owner') en PATCH /members/:uid, así que ofrecer
  // el selector a admin sólo cosecharía 403. Ver LANZAMIENTO-ESTADO.md (G3).
  const canManage = ['owner', 'admin'].includes(currentUserRole);
  const canChangeRole = currentUserRole === 'owner';

  if (!members || members.length === 0) {
    return (
      <div className="empty-state">
        <h3>{t('members.emptyTitle')}</h3>
        <p>{t('members.emptyDescription')}</p>
      </div>
    );
  }

  return (
    <div className="members-tab">
      <h2>{t('members.title')}</h2>

      <table className="members-table">
        <thead>
          <tr>
            <th>{t('members.headerMember')}</th>
            <th>{t('members.headerRole')}</th>
            <th>{t('members.headerJoined')}</th>
            {canManage && <th>{t('members.headerActions')}</th>}
          </tr>
        </thead>
        <tbody>
          {members.map((member) => (
            <tr key={member.uid}>
              <td>
                <div className="member-info">
                  <strong>{member.displayName || member.email}</strong>
                  <span className="member-email">{member.email}</span>
                </div>
              </td>
              <td>
                {canChangeRole && member.role !== 'owner' ? (
                  <select
                    className="role-select"
                    value={member.role}
                    onChange={(e) => onChangeRole(member.uid, e.target.value)}
                  >
                    {/* Roles asignables (rolesMatrix, sin viewer). Si el miembro
                        ya tiene un rol legacy fuera del catálogo (p.ej. viewer),
                        se incluye para que el select renderice su valor actual. */}
                    {(ASSIGNABLE_ROLES.includes(member.role)
                      ? ASSIGNABLE_ROLES
                      : [...ASSIGNABLE_ROLES, member.role]
                    ).map((r) => (
                      <option key={r} value={r}>
                        {r.charAt(0).toUpperCase() + r.slice(1)}
                      </option>
                    ))}
                  </select>
                ) : (
                  <span className={`role-badge ${member.role}`}>
                    {member.role}
                  </span>
                )}
              </td>
              <td>
                {member.joinedAt
                  ? (() => {
                      try {
                        if (member.joinedAt.toDate) {
                          return new Date(member.joinedAt.toDate()).toLocaleDateString();
                        } else if (member.joinedAt._seconds) {
                          return new Date(member.joinedAt._seconds * 1000).toLocaleDateString();
                        } else {
                          return new Date(member.joinedAt).toLocaleDateString();
                        }
                      } catch (e) {
                        return 'N/A';
                      }
                    })()
                  : 'N/A'}
              </td>
              {canManage && (
                <td>
                  {member.role !== 'owner' ? (
                    <button
                      className="btn-danger btn-sm"
                      onClick={() => onRemoveMember(member.uid, member.email)}
                    >
                      {t('members.remove')}
                    </button>
                  ) : (
                    <span className="text-muted">—</span>
                  )}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      {!canManage && (
        <p className="info-message">
          {t('members.noPermissions')}
        </p>
      )}
    </div>
  );
}
